<!-- Signed-in-as chip / button -->
<button
    mat-button
    class="h-10 rounded-full px-1 sm:pr-3"
    [matMenuTriggerFor]="userActions"
>
    <div class="flex items-center gap-2">
        <!-- Avatar -->
        <span
            class="relative flex h-8 w-8 flex-0 items-center justify-center overflow-hidden rounded-full bg-primary text-sm font-semibold uppercase text-on-primary"
        >
            @if (showAvatar && user.avatar) {
                <img
                    class="h-full w-full rounded-full object-cover"
                    [src]="user.avatar"
                />
            } @else {
                {{ displayName.charAt(0) }}
            }
            <span
                class="absolute bottom-0 right-0 h-2 w-2 rounded-full ring-1 ring-white dark:ring-gray-900"
                [ngClass]="{
                    'bg-green-500': user.status === 'online',
                    'bg-amber-500': user.status === 'away',
                    'bg-red-500': user.status === 'busy',
                    'bg-gray-400':
                        !user.status || user.status === 'not-visible',
                }"
            ></span>
        </span>

        <!-- Name + role -->
        <span class="hidden flex-col items-start leading-none sm:flex">
            <span
                class="text-[10px] font-medium uppercase tracking-wide text-secondary"
            >
                Signed in as
            </span>
            <span class="mt-0.5 flex items-center gap-1.5">
                <span class="text-sm font-semibold normal-case">{{
                    displayName
                }}</span>
                @if (roleName) {
                    <span
                        class="rounded bg-primary-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-none text-primary-700 dark:bg-primary-500/20 dark:text-primary-300"
                    >
                        {{ roleName }}
                    </span>
                }
            </span>
        </span>
    </div>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Signed in as</span>
            <span class="mt-1.5 text-md font-medium">{{ user.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="goToProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Profile</span>
    </button>
    <!-- <button mat-menu-item>
        <mat-icon [svgIcon]="'heroicons_outline:cog-8-tooth'"></mat-icon>
        <span>Settings</span>
    </button> -->
    <button mat-menu-item [matMenuTriggerFor]="userStatus">
        <mat-icon
            [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"
        ></mat-icon>
        <span>Status</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Sign out</span>
    </button>
</mat-menu>

<mat-menu class="user-status-menu" #userStatus="matMenu">
    <button mat-menu-item (click)="updateUserStatus('online')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Online</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('away')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Away</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('busy')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Busy</span>
    </button>
    <button mat-menu-item (click)="updateUserStatus('not-visible')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Invisible</span>
    </button>
</mat-menu>
